export const parseLoginErrors = (err) => {
    let message;
    let code = null;
    if (err && err.response) {
        err = err.response;
    }
    if (err.errors && err.errors['0'] && err.errors['0'].code) {
        code = err.errors['0'].code;
        message = err.errors['0'].message;
    } else if (err.errors) {
        if (err.errors.msg) {
            message = err.errors.msg;
        } else if (Array.isArray(err.errors.error)) {
            message = err.errors.error[0];
        } else {
            message = err.errors.error;
        }
        if (err.errors.code) code = err.errors.code;
    } else if (err.status === false) {
        message = err.message;
        code = err.code;
    } else {
        message = err.msg || null;
    }

    // TODO return new Error
    return {
        message,
        completeError: err,
        code
    };
};


// WEBPACK FOOTER //
// ./src/AAF/Auth/parseError.js